import { getTransactionAnalytics } from '@ynap/analytics';

export function trackStepSubmit(props) {
    const { pageAnalyticsStep, checkoutAnalytics } = props;
    return {
        event: 'continue',
        effect: 'continue to next step',
        category: {
            subCategory: pageAnalyticsStep,
        },
        ...(checkoutAnalytics ? { transaction: getTransactionAnalytics(checkoutAnalytics) } : {}),
    };
}
